///ts:ref=pixi.js
/// No file or directory matched name "pixi.js" ///ts:ref:generated

/**
 * overrides GLTexture upload, adds SuperAtlas as source
 * @param source
 * @returns {any}
 */

declare module PIXI.glCore {
	interface GLTexture {
		/**
		 * either number of atlas elements uploaded
		 * either version of dynamic canvas texture
		 */
		_sourceID: number,
		_internalFormat: number,

		uploadFloatTexturePartial(offset: number, buf: Float32Array): void
	}
}

namespace PIXI.glCore {
	(Object as any).assign(GLTexture.prototype, {
		_sourceID: -1,
		internalFormat: 0,

		uploadWithoutSuper: PIXI.glCore.GLTexture.prototype.upload,
		upload: function (source: any) {
			if (source.upload) {
				source.upload(this);
			} else {
				this.uploadWithoutSuper(source);
			}
			this._sourceID = source._updateID || 0;
		},
		uploadFloatTexturePartial: function (offset: number, buf: Float32Array) {
			this.bind();
			const gl = this.gl;
			const width = this.width;
			
			gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, this.premultiplyAlpha);

			let row1 = (offset >> 2) / width | 0;
			const col1 = (offset >> 2) % width | 0;
			const offset1 = col1 > 0 ? (width - col1) << 2 : 0;

			const row2 = ((offset + buf.length) >> 2) / width | 0;
			const col2 = ((offset + buf.length) >> 2) % width | 0;
			const offset2 = buf.length - (col2 << 2);

			if (row1 === row2) {
				gl.texSubImage2D(
					gl.TEXTURE_2D, 0,
					col1, row1,
					col2 - col1, 1,
					gl.RGBA, gl.FLOAT, buf
				);
				return;
			}

			if (col1 > 0) {
				gl.texSubImage2D(
					gl.TEXTURE_2D, 0,
					col1, row1,
					width - col1, 1,
					gl.RGBA, gl.FLOAT, buf.subarray(0, offset1)
				);
				row1++;
			}
			if (col2 > 0) {
				gl.texSubImage2D(
					gl.TEXTURE_2D, 0,
					0, row2,
					col2, 1,
					gl.RGBA, gl.FLOAT, buf.subarray(offset2, buf.length)
				);
			}
			if (row1 < row2) {
				gl.texSubImage2D(
					gl.TEXTURE_2D, 0,
					0, row1,
					width, row2 - row1,
					gl.RGBA, gl.FLOAT, buf.subarray(offset1, offset2)
				);
			}
		}
	});
}
